var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPmDone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 477"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.52036 13C5.12296 13.0002 4.74183 12.8439 4.46106 12.5656L1.25845 9.39787C0.913849 9.05679 0.913849 8.50389 1.25845 8.1628C1.60317 7.82183 2.16194 7.82183 2.50666 8.1628L5.52036 11.1448L13.4933 3.25573C13.8381 2.91476 14.3968 2.91476 14.7415 3.25573C15.0862 3.59682 15.0862 4.14971 14.7415 4.4908L6.57966 12.5656C6.29889 12.8439 5.91776 13.0002 5.52036 13Z",
    fill: "var(--fill-0, #7281DC)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmDone);
export default __webpack_public_path__ + "static/media/pm-done.bc01063c2cda21800fe0ab568f4058f9.svg";
export { ForwardRef as ReactComponent };